import { InvoiceUploadStateType } from './useInvoiceUpload.types'
import useGlobalState from '../useGlobalState'

const useInvoiceUploadState = () => {
    return useGlobalState<InvoiceUploadStateType[]>('invoiceFileUpload', [])
}

export default useInvoiceUploadState